module.exports = __webpack_public_path__ + "static/media/ariel-win.797d9a20.png";